import s from "./vendorBadge.module.css";
import {ritaIcon} from "../../../assets";

const VendorBadge = (props) => {
    // Destructured props
    let {
        tier =        "none",
        description = "",
        tierData =       {},
        debug =         null
    } = props;

    // Formats the tier label to lowercase text
    tier = tier.toLowerCase();

    // Extra validation layer
    tier = tier.includes("tabela") ?
        tier.split("-").slice(-1)[0] :
        tier;

    // Bridge for the standard table subscription tier
    tier = tier === "padrão" ? "padrao" : tier;

    // Some fallback stuff
    // (not to be 100% reliable, but it should work in some corner cases)
    const TIERS = {
        assinante: {
            color: "#9146FF",
            label: "Tabela Assinante"
        },
        padrao:    {
            color: "#706BFF",
            label: "Tabela Padrão"
        },
        especial:    {
            color: "#FF815E",
            label: "Tabela Especial"
        }
    }

    // Validation for when the user is not a Rita member.
    // And also prevents component from rendering
    // if the given tier isn't included in the object.
    if (
        Object.keys(TIERS).indexOf(tier) < 0 &&
        (
            !tierData.label ||
            !tierData.tableCode
        )
    ) {
        return null;
    }

    return (
        <div
            className={`${s.root} dark:!bg-contrast-yellow`}
            style={{
                backgroundColor: tierData.color || TIERS[tier].color
            }}
        >
            <img
                src={ritaIcon}
                className={s.icon}
                alt="Rita logo"
            />
            <div className={`flex flex-col gap-y-0.5`}>
                <p className={`${s.label}`}>
                    {tierData.label || TIERS[tier].label}
                </p>
                <p className={`text-white text-[12px] leading-none`}>
                    {description}
                </p>
            </div>
        </div>
    )
}

export default VendorBadge;
